/**
 * @desc 新增退货单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.AsMaterialRejectBillRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/asMaterialRejectBill/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
